export default "/assets/images/technology-graph-01.svg?6499cf487bc301ed61e0f1229b71ad33";